import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=27d6196c&scoped=true"
var script = {}
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=27d6196c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d6196c",
  null
  
)

export default component.exports